import { TemplateProfile } from "../../../core/entities/templateProfile";
import { TemplateProfileDto } from "../templateProfileDto";
import { mapDtoToTemplate } from "./mapDtoToTemplate";

export function mapDtoToTemplateProfile(
    templateProfileDto: TemplateProfileDto
): TemplateProfile {
    return {
        history: templateProfileDto.history.map((x, i) =>
            mapDtoToTemplate(x, i + 1)
        ),
        draft:
            templateProfileDto.draft != null
                ? mapDtoToTemplate(templateProfileDto.draft)
                : undefined,
        published:
            templateProfileDto.published != null
                ? mapDtoToTemplate(
                      templateProfileDto.published,
                      templateProfileDto.history.length + 1
                  )
                : undefined,
        type: templateProfileDto.type
    };
}
